import { GridValidRowModel } from "@mui/x-data-grid";
import { useState } from "react";
import { OpDelete, OpEdit } from "src/assets/icons";
import { Box } from "src/components/MuiGenerals";
import OpIconButton from "src/components/OpIconButton";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { usePermission, useTranslation } from "src/hooks";
import { EditRecordFields } from "../types/EditRecipientFields";
import useDeleteRecipientDialog from "./useDeleteRecipientDialog";
import useEditRecipientDialog from "./useEditRecipientDialog";
import { FeatureCodes } from "src/utils/constant";
import { ViewGroupGetListRes } from "../types/ViewGroupGetListRes";

const EditPermission =
  FeatureCodes.assetManagement.ContractSweepRecipentSetting
    .ContractSweepRecipent.edit;
const DeletePermission =
  FeatureCodes.assetManagement.ContractSweepRecipentSetting
    .ContractSweepRecipent.delete;

const useOperationCell = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();

  //state of dialog
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  //state of selected data
  const [selectedRow, setSelectedRow] = useState<
    GridValidRowModel & { rawData: ViewGroupGetListRes }
  >();
  const [editRecordFields, setEditRecordFields] = useState<
    EditRecordFields | undefined
  >();

  //edit dialog hook
  const { renderEditRecordDialog, renderEditDoubleConfirmDialog } =
    useEditRecipientDialog({
      isOpen: isEditDialogOpen,
      onClose: () => {
        setIsEditDialogOpen(false);
        setEditRecordFields(undefined);
        setSelectedRow(undefined);
      },
      editRecordFields: editRecordFields,
      setEditRecordFields: setEditRecordFields,
      selectedRow: selectedRow,
    });

  //delete dialog hook
  const { renderDeleteDialog, renderDeleteDoubleConfirmDialog } =
    useDeleteRecipientDialog({
      isOpen: isDeleteDialogOpen,
      selectedRow: selectedRow,
      onClose: () => {
        setIsDeleteDialogOpen(false);
        setSelectedRow(undefined);
      },
    });

  const renderOperationCell = (params: Params<ViewGroupGetListRes>) => {
    const onEditClick = () => {
      setIsEditDialogOpen(true);
      setSelectedRow(params.row);
      setEditRecordFields({
        probability: params.row.rawData.probability?.toString(),
        status: params.row.rawData?.status?.toString(),
      });
    };
    const onDeletClick = () => {
      setIsDeleteDialogOpen(true);
      setSelectedRow(params.row);
    };

    return (
      <Box display={"flex"} flexDirection={"row"} gap={1}>
        {hasPermission(EditPermission) && (
          <OpIconButton title={t("edit")} url={OpEdit} onClick={onEditClick} />
        )}
        {hasPermission(DeletePermission) && (
          <OpIconButton
            title={t("delete")}
            url={OpDelete}
            onClick={onDeletClick}
          />
        )}
      </Box>
    );
  };

  const renderDialogInOperationCell = () => {
    return (
      <>
        {renderEditRecordDialog()}
        {renderDeleteDialog()}
        {renderEditDoubleConfirmDialog()}
        {renderDeleteDoubleConfirmDialog()}
      </>
    );
  };

  return {
    renderOperationCell,
    renderDialogInOperationCell,
  };
};
export default useOperationCell;
